export const InitialValues = {
  companyId: "",
  title: "",
  description: "",
};
